import { isTruthy } from 'notable-common';
import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowFilterConfigSchema, FlowLimitConfigSchema, FlowSortConfigSchema, } from '../filterConfig.js';
import { FlowBlockType } from '../type.js';
export const FlowFilterListBlockConfigSchema = z.object({
    originalList: z.string().min(1),
    filterConfig: FlowFilterConfigSchema.transform((filterConfig) => isTruthy(filterConfig.filterConditions.length) ? filterConfig : undefined).optional(),
    sortConfig: FlowSortConfigSchema.transform((sortConfig) => isTruthy(sortConfig.fieldToSort) ? sortConfig : undefined).optional(),
    limitConfig: FlowLimitConfigSchema.optional(),
});
export const FlowFilterListBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.FilterList),
    config: FlowFilterListBlockConfigSchema,
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.ListOfObjects),
});
//# sourceMappingURL=config.js.map